export default "__VITE_ASSET__BYnrbRQx__"